import { DeviceUpdate } from '../types';

const VALID_STATUS = ['pending', 'downloading', 'installing', 'installed', 'failed'];

// O launcher grava "error" em alguns pontos e "failed" nos demais
export function parseUpdateStatus(status: unknown): DeviceUpdate['status'] {
  if (status === 'error') return 'failed';
  if (VALID_STATUS.includes(status as string)) return status as DeviceUpdate['status'];
  return 'pending';
}

// Maior que o intervalo de verificação periódica do launcher (30min)
const STALLED_UPDATE_MS = 45 * 60 * 1000;

// Dispositivo respondendo mas sem sinal de ter recebido a atualização
export function isUpdateStalled(
  update: Pick<DeviceUpdate, 'status' | 'createdAt'>,
  deviceOnline: boolean,
  now: number = Date.now()
): boolean {
  return update.status === 'pending'
    && deviceOnline
    && (now - update.createdAt) > STALLED_UPDATE_MS;
}

export { STALLED_UPDATE_MS };
